<template>
  <div>
    <div class="sidebar_container">
      <div class="sidebar_header">
        <CRow class="m-0">
          <CCol cols="10" lg="10" md="10" sm="10" class="text-left">
            <span v-if="history.length > 1" class="pointer" @click="removeSidebarHistoryStep()">
              <i class="fas fa-arrow-circle-left mr-1"/>
            </span>            
            <span class="sidebar_subject">
							{{!platformAnnouncementIdExternal ? $t('admin.New_announcement') : $t('admin.Edit_announcement')}}
            </span>
          </CCol>
          <CCol cols="2" lg="2" md="2" sm="2" class="text-right">
            <span @click="closeSidebarRight();"><i class="fas fa-times"/></span>        
          </CCol>
        </CRow>
      </div>
      <div class="sidebar_content">
        <CRow class="m-0">
          <CCol cols="12" lg="12" class="pt-0">            
            <quick-edit type="text" mode="ignore" :buttonOkText="$t('Save')" :buttonCancelText="$t('Dismiss')" v-model="announcement.title">                        
              <h2 class="m-0">{{announcement.title ? announcement.title : $t('common.Click_to_set_title')}}<i class="icon edit fas fa-pen ml-1"/></h2>
            </quick-edit>
          </CCol>           
        </CRow>
        <CRow class="m-0">          
          <CCol cols="12" lg="12" class="pt-0">
            <div class="wysiwyg">
              <label>{{$t('admin.Your_announcement')}}</label>                
              <ckeditor ref="contentEditor" @input="countdown()" :editor="editor" v-model="announcement.announcement" :config="editorConfig"></ckeditor>
            </div>            
          </CCol>            
        </CRow>

        <CRow class="m-0">
          <CCol cols="12" lg="12" class="pt-0">
            <label>{{$t('admin.Schedule_announcement_for')}}</label>
            <p v-if="announcementAnnouncedAt !== null" class="meta mb-2">{{$t('admin.Announcement_scheduled_for')}}: {{announcementAnnouncedAt | moment("DD-MM-YYYY HH:mm")}}</p>
            <b-datetimepicker v-model="announcementAnnouncedAt" :placeholder="$t('common.click_to_select')" inline editable :datepicker="datepickerOptions">
              <template #left>
                <CButton color="primary" @click="announcementAnnouncedAt = new Date();"><i class="fas fa-clock mr-1"/>{{$t('Now')}}</CButton>
              </template>
              <template #right>
                <CButton color="secondary" @click="announcementAnnouncedAt = null;"><i class="fas fa-times mr-1"/>{{$t('Clear')}}</CButton>
              </template>                    
            </b-datetimepicker>
          </CCol>
        </CRow>


        <CRow class="m-0">          
          <CCol cols="12" lg="12" class="pt-0">
            <CInput type="text" :label="$t('admin.Link_to_external_page') + ' ' + $t('common.optional')" class="m-0" v-model="announcement.external_link"/>          
          </CCol>            
        </CRow>        
      </div>
      <div class="sidebar_footer">
        <CRow class="m-0">
          <CCol cols="12" lg="12">
						<div v-if="!platformAnnouncementIdExternal">
							<CButton color="primary" @click="newAnnouncement(announcement);"><i class="fas fa-check mr-1"/>{{$t('Save')}}</CButton>
							<CButton color="secondary" @click="closeSidebarRight();"><i class="fas fa-times mr-1"/>{{$t('Dismiss')}}</CButton>
						</div> 						   
						<div v-else>
							<CButton color="primary" @click="updateAnnouncement(announcement);"><i class="fas fa-check mr-1"/>{{$t('Save')}}</CButton>
							<CButton color="secondary" @click="closeSidebarRight();"><i class="fas fa-times mr-1"/>{{$t('Dismiss')}}</CButton>
          	</div>
          </CCol>
        </CRow>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import QuickEdit from 'vue-quick-edit';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UploadAdapter } from '@/components/upload/upload-adapter';

export default {
  name: 'platformAnnouncementDetails',
  props: ['history', 'platformAnnouncementIdExternal'],
  components: {
    Multiselect,
    QuickEdit
  },
  watch: {
    $props: {
      handler() {
        if(this.platformAnnouncementIdExternal) {
          this.getAnnouncementDetails();                  
        } else {
          this.resetAnnouncementData();
        }
      },
      deep: true,
      immediate: true,
    }
  }, 
  data() {
    return {
      apiBaseUrl: null,
      clientToken: null,
			announcement: {},
      announcementAnnouncedAt: null,
      editor: ClassicEditor,
      editorConfig: {
        placeholder: this.$t('admin.Write_your_announcement_here'),
        toolbar: [ 'undo', 'redo', 'bulletedList', 'numberedList' ],
      },
      datepickerOptions: {
        yearsRange: [0, 10],
        firstDayOfWeek: 1,
        showWeekNumber: true
      },       
      maxCount: {
        announcement: 2000
      },
      remainingCount: {
        announcement: 2000
      },        
    }
  },
  methods: {
    getAnnouncementDetails() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/superadmin/announcement/' + this.platformAnnouncementIdExternal)
      .then(res => {
        this.announcement = res.data.data;
        // Trigger countdown function to calculate remaining characters for content
        this.countdown();        
        // Set the value of the datetime picker
        this.announcementAnnouncedAt = new Date(this.announcement.announce_at);                
      })
      .catch(err => {
        console.error(err); 
      });
    },
    newAnnouncement(data) {
      let params = {};
      params.announcementData = data;
      if(!params.announcementData.external_link) params.announcementData.external_link = null;

      // Get announced at datetime elements to create the correct datetime string
      if(this.announcementAnnouncedAt) {
        params.announcementData.announce_at = this.$luxon(this.announcementAnnouncedAt.toISOString(), "yyyy-MM-dd HH:mm:ss");
      }

      if(this.validateAnnouncement(params) === true) {
        axios.post(process.env.VUE_APP_API_URL + '/v1/superadmin/announcement', params)
        .then(res => {
          this.$buefy.toast.open({ message: this.$t('common.Marketplace_set_added'), type: 'is-success', duration: 2000 });
          // Emit the update_platform_announcements event
          this.$bus.$emit('update_platform_announcements');
          // Reset the data
          this.resetAnnouncementData();
          // Close the sidebar
          this.closeSidebarRight();         
        })
        .catch(err => {
          console.error(err); 
          this.$buefy.toast.open({ message: this.$t('error_alert_text'), type: 'is-danger', duration: 2000 });
        })
      } else {
        this.$buefy.toast.open({ message: this.$t('common.mandatory_fields'), type: 'is-danger', duration: 2000 });
      }
    },
    updateAnnouncement(data) {
      let params = {}
      params.announcementData = data;
      if(!params.announcementData.external_link) params.announcementData.external_link = null;
           
      // Get announced at datetime elements to create the correct datetime string
      if(this.announcementAnnouncedAt) {
        params.announcementData.announce_at = this.$luxon(this.announcementAnnouncedAt.toISOString(), "yyyy-MM-dd HH:mm:ss");
      }

      if(this.validateAnnouncement(params) === true) {
        axios.put(process.env.VUE_APP_API_URL + '/v1/superadmin/announcement/' + this.platformAnnouncementIdExternal, params)
        .then(res => {
          this.$buefy.toast.open({ message: this.$t('common.Marketplace_set_updated'), type: 'is-success', duration: 2000 });
          // Emit the update_platform_announcements event
          this.$bus.$emit('update_platform_announcements');
          // Reset the data
          this.resetAnnouncementData();
          // Close the sidebar
          this.closeSidebarRight();  
        })
        .catch(err => {
          console.error(err); 
          this.$buefy.toast.open({ message: this.$t('error_alert_text'), type: 'is-danger', duration: 2000 });
        })
      } else {
        this.$buefy.toast.open({ message: this.$t('common.mandatory_fields'), type: 'is-danger', duration: 2000 });
      }      
    },
    validateAnnouncement(params) {
      let title = params.announcementData.title;
      let announcement = params.announcementData.announcement;
      let announce_at = params.announcementData.announce_at;

      // Check if base information for the set is available
      if(title && announcement && announce_at) {
        return true;
      } else {
        return false;
      }
    },    
    resetAnnouncementData() {
      this.announcement = {
        title: null,
        announcement: null,
        announce_at: null,
        external_link: null,
      };
      // Set the value of the datetime picker
      this.announcementAnnouncedAt = new Date();         
    },
    countdown() {
      this.remainingCount.announcement = this.maxCount.announcement - this.announcement.announcement.length;
    },       
  },
  mounted: function() {
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.clientToken = localStorage.getItem('token');
  }  
}
</script>